import { apiGet } from "../../api/apiClient";

class CtaMainActions {
  static getIntegratedCta = async (id) => {
    return await apiGet(`/cta/public/location/${id}`);
  };
}

export default CtaMainActions;
